import { isPlainObject, mergeWith } from 'lodash'

export default function (arrayOfObjects) {
    const arrayOfPlainObjects = arrayOfObjects.filter(isPlainObject)

    return mergeWith({}, ...arrayOfPlainObjects)
}